// extracted by mini-css-extract-plugin
export default {"exchangeSide":"style_exchangeSide__Vqwf0","balances":"style_balances__bTn1h","totalBalance":"style_totalBalance__2+aPQ","tokens":"style_tokens__Lh57F","space":"style_space__1v4uC"};